module.exports = __webpack_public_path__ + "img/footer2.770b9857.png";